import { render } from "./PartWhyUs.vue?vue&type=template&id=32dc07a4"
import script from "./PartWhyUs.vue?vue&type=script&lang=js"
export * from "./PartWhyUs.vue?vue&type=script&lang=js"

import "./PartWhyUs.vue?vue&type=style&index=0&id=32dc07a4&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__